import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const axios = require('axios');

export default new Vuex.Store({
  state: {
    loggedin: false,
    authCheckInProgress: true,
    username: "",
    password: "",
    oauthError: "",
    authError: ""
  },
  mutations: {},
  actions: {
    setOauthErrorFromLocation () {
      var search = window.location.search || '';
      var params = new URLSearchParams(search);
      var oauthError = params.get('oauthError');

      if (oauthError) {
        this.state.oauthError = oauthError;
        params.delete('oauthError');

        var cleanedQuery = params.toString();
        var newUrl = window.location.pathname + (cleanedQuery ? '?' + cleanedQuery : '') + window.location.hash;
        window.history.replaceState({}, document.title, newUrl);
      }
    },
    checkForLogin() {

            var _this = this;
            _this.state.authCheckInProgress = true;

            return axios.get('/api/persons/session', {
              // Browser-Session läuft über HttpOnly Session-Cookie (MS_SESSION),
              // daher Login-Status immer serverseitig per API + Credentials prüfen.
              withCredentials: true,
            })
            .then(function (response) {
              if (response.data && response.data.loggedIn) {
                _this.state.loggedin = true;
                _this.state.username = response.data.username || "";
                _this.state.authError = "";
              } else {
                _this.state.loggedin = false;
                // Falls wir explizit nicht eingeloggt sind, löschen wir den Usernamen
                // Aber NUR wenn wir nicht gerade im Login-Formular tippen (username/password belegt)
                if (!_this.state.password) {
                  _this.state.username = "";
                }
              }
            })
            .catch(function (error) {
              console.log(error);
              _this.state.loggedin = false;
              _this.state.authError = "Anmeldung konnte nicht geprüft werden. Bitte erneut einloggen.";

              // Bei technischem Fehler (z.B. API nicht erreichbar) sicherheitshalber logout aufrufen
              return axios.get('/api/persons/logout', {
                withCredentials: true,
              }).catch(function (logoutError) {
                console.log(logoutError);
              });
            })
            .finally(function () {
              _this.state.authCheckInProgress = false;
            });
    },
    loginViaZoho () {
      this.state.oauthError = "";
      this.state.authError = "";
      this.state.authCheckInProgress = true;
      this.state.username = "";
      this.state.password = "";

      // Defensive Bereinigung: falls globaler Authorization-Header gesetzt wurde,
      // vor OAuth-Redirect entfernen.
      delete axios.defaults.headers.common.Authorization;

      window.location.href = '/api/oauth/zoho/start?frontend=admin';
    },
    logout () {
      var _this = this;
      _this.state.authCheckInProgress = true;

      return axios.get('/api/persons/logout', {
        withCredentials: true,
      })
      .catch(function (error) {
        // Auch bei Fehler lokal sicher ausloggen.
        console.log(error);
      })
      .finally(function () {
        _this.state.loggedin = false;
        _this.state.authCheckInProgress = false;
        _this.state.username = "";
        _this.state.password = "";
        _this.state.oauthError = "";
        _this.state.authError = "";

        // Defensive Bereinigung möglicher globaler Auth-Header.
        delete axios.defaults.headers.common.Authorization;

        if (window.location.hash !== '#/') {
          window.location.hash = '/';
        }
      });
    }
  }
});
